
import React, { useEffect, useRef, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import * as XLSX from 'xlsx';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    StyleSheet
} from '@react-pdf/renderer';
import Loading from './Loading';

const FindLotDetail = () => {

    const [isLoading, setIsLoading] = useState(false);

    const usershopid = localStorage.getItem('MYPCKARTUSER')
        ? JSON.parse(localStorage.getItem('MYPCKARTUSER'))[0].id
        : '0';

    const [RoomType, setRoomType] = useState([]);
    const [Room, setRoom] = useState([]);
    const [deptdata, setdeptdata] = useState([]);
    const [data, setData] = useState([]);

    const today = new Date();

    const [FebData, setFebData] = useState([]);
    const [WData, setWData] = useState([]);

    const [frmdata, setfrmdata] = useState({
        fromdate: "2024-01-01",
        todate: today.toISOString().split('T')[0],
        deptcode: 0,
        lotno: "",
        status: 1
    });

    const [totalSums, setTotalSums] = useState({});

    const [itemdetail, setitemdetail] = useState({
        Washername: "",
        Washercode: 0,
        fabname: "",
        fabcode: 0
    });

    const {
        fabcode,
        fabname,
        Washercode,
        Washername
    } = itemdetail;

    const {
        fromdate,
        todate,
        status,
        deptcode,
        lotno
    } = frmdata;

    const tableRef = useRef(null);


    // =========================================================
    // FABRICATOR
    // =========================================================

    const onChangevalueFab = (fabcode, fabname) => {

        setitemdetail({
            ...itemdetail,
            fabcode: fabcode,
            fabname: fabname
        });

    };


    // =========================================================
    // WASHER
    // =========================================================

    const onChangevalueWasher = (Washercode, Washername) => {

        setitemdetail({
            ...itemdetail,
            Washercode: Washercode,
            Washername: Washername
        });

    };


    // =========================================================
    // INPUT CHANGE
    // =========================================================

    const onChangevalue = (e) => {

        const {
            name,
            value
        } = e.target;

        const sanitizedValue = value.replace(
            /['"!`@#$%^&*+{}|;:,.<>?=]/g,
            ''
        );

        setfrmdata({
            ...frmdata,
            [name]: sanitizedValue
        });

    };


    // =========================================================
    // LOAD DATA
    // =========================================================

    const loaddata = async () => {

        setIsLoading(true);

        try {

            const apidata =
                lotno === ""
                    ? `PurchaseMasFindAllDetail/${usershopid}`
                    : `PurchaseMasFindAllSearchDetail/${usershopid}/${lotno}`;

            const billResponse = await axios.get(
                `${hostlink}/${apidata}`
            );

            const result = billResponse.data || [];

            console.log("Lot Detail Data Found...", result);

            setData(result);

        } catch (error) {

            console.log("Data Not Found...", error);

            setData([]);

        } finally {

            setIsLoading(false);

        }
    };


    // =========================================================
    // MASTER DATA
    // =========================================================

    useEffect(() => {

        axios
            .get(`${hostlink}/${usershopid}/FabMasCont`)
            .then((Response) => {
                setFebData(Response.data);
            })
            .catch(() => {
                console.log("Fabricator data not found");
            });


        axios
            .get(`${hostlink}/${usershopid}/WasherMas`)
            .then((Response) => {
                setWData(Response.data);
            })
            .catch(() => {
                console.log("Washer data not found");
            });

    }, [usershopid]);


    // =========================================================
    // EXCEL
    // =========================================================

    const exportToExcel = () => {

        if (!tableRef.current || data.length === 0) {
            return;
        }

        const ws = XLSX.utils.table_to_sheet(
            tableRef.current
        );

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            'Lot Details'
        );

        XLSX.writeFile(
            wb,
            'Pending Lot.xlsx'
        );

    };


    // =========================================================
    // QTY CALCULATION
    // =========================================================

    const getQty = (res) => {

        if (res.entrytype === 1) {
            return res.pcs ? `${res.pcs}` : '';
        }

        if (res.entrytype === 2) {
            return res.washqty ? `${res.washqty}` : '';
        }

        if (res.entrytype === 3) {
            return res.finishqty ? `${res.finishqty}` : '';
        }

        if (res.entrytype === 4) {
            return res.godwstk ? `${res.godwstk}` : '';
        }

        return '';

    };


    // =========================================================
    // TYPE
    // =========================================================

    const getType = (res) => {

        return [
            res.fabname ? 'Fabricator' : '',
            res.wname ? 'Washing' : '',
            res.finisharname ? 'Finishing' : ''
        ]
            .filter(Boolean)
            .join(' | ');

    };


    // =========================================================
    // NAME
    // =========================================================

    const getName = (res) => {

        return [
            res.fabname ? res.fabname : '',
            res.wname ? res.wname : '',
            res.finisharname ? res.finisharname : ''
        ]
            .filter(Boolean)
            .join(' | ');

    };


    // =========================================================
    // TOTAL QTY
    // =========================================================

    const totalQty = data.reduce(
        (total, res) => {

            let qty = 0;

            if (res.entrytype === 1) {
                qty = parseFloat(res.pcs) || 0;
            }

            if (res.entrytype === 2) {
                qty = parseFloat(res.washqty) || 0;
            }

            if (res.entrytype === 3) {
                qty = parseFloat(res.finishqty) || 0;
            }

            if (res.entrytype === 4) {
                qty = parseFloat(res.godwstk) || 0;
            }

            return total + qty;

        },
        0
    );


    // =========================================================
    // UNIQUE LOT COUNT
    // =========================================================

    const uniqueLots = [
        ...new Set(
            data
                .map(item => item.billno)
                .filter(Boolean)
        )
    ].length;


    return (

        <div
            className="container-fluid py-3"
            style={{
                minHeight: '100vh',
                background: '#f5f7fb'
            }}
        >

            {/* =================================================
                TOP HEADER
            ================================================= */}

            <div className="row align-items-center mb-3">

                <div className="col-md-7">

                    <div className="d-flex align-items-center">

                        <div
                            className="d-flex align-items-center justify-content-center me-3"
                            style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '14px',
                                background:
                                    'linear-gradient(135deg,#0d6efd,#4f8dfd)',
                                color: '#fff',
                                boxShadow:
                                    '0 7px 20px rgba(13,110,253,.25)'
                            }}
                        >

                            <i
                                className="fa-solid fa-circle-info"
                                style={{
                                    fontSize: '21px'
                                }}
                            ></i>

                        </div>

                        <div>

                            <h4
                                className="mb-0 fw-bold text-dark"
                            >
                                Lot Details
                            </h4>

                            <div
                                className="text-muted"
                                style={{
                                    fontSize: '13px'
                                }}
                            >
                                Track fabricator, washing and finishing status
                            </div>

                        </div>

                    </div>

                </div>


                <div className="col-md-5 text-md-end mt-3 mt-md-0">

                    <span
                        className="badge rounded-pill px-3 py-2"
                        style={{
                            background: '#fff',
                            color: '#495057',
                            border: '1px solid #e9ecef',
                            boxShadow:
                                '0 3px 10px rgba(0,0,0,.04)'
                        }}
                    >

                        <i className="fa-regular fa-calendar me-2 text-primary"></i>

                        {fromdate}

                    </span>

                </div>

            </div>


            {/* =================================================
                SEARCH CARD
            ================================================= */}

            <div
                className="card border-0 mb-3"
                style={{
                    borderRadius: '18px',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >

                <div className="card-body p-3 p-md-4">

                    <div className="row align-items-end g-3">


                        {/* LOT SEARCH */}

                        <div className="col-xl-5 col-lg-5 col-md-6">

                            <label
                                className="form-label fw-semibold text-dark mb-2"
                            >
                                <i className="fa-solid fa-magnifying-glass text-primary me-2"></i>
                                Search Lot Number
                            </label>

                            <div
                                className="input-group"
                                style={{
                                    height: '43px'
                                }}
                            >

                                <span
                                    className="input-group-text bg-white border-end-0"
                                >
                                    <i className="fa-solid fa-barcode text-muted"></i>
                                </span>

                                <input
                                    type="text"
                                    id="lotno"
                                    name="lotno"
                                    value={lotno}
                                    onChange={onChangevalue}
                                    onKeyDown={(e) => {

                                        if (e.key === 'Enter') {
                                            loaddata();
                                        }

                                    }}
                                    placeholder="Enter Lot No..."
                                    className="form-control border-start-0 ps-0"
                                    style={{
                                        boxShadow: 'none'
                                    }}
                                />

                                {lotno && (

                                    <button
                                        type="button"
                                        className="btn bg-white border border-start-0 text-muted"
                                        onClick={() => {

                                            setfrmdata({
                                                ...frmdata,
                                                lotno: ""
                                            });

                                        }}
                                    >

                                        <i className="fa-solid fa-xmark"></i>

                                    </button>

                                )}

                            </div>

                            <small className="text-muted">
                                Press Enter to search
                            </small>

                        </div>


                        {/* SHOW */}

                        <div className="col-xl-2 col-lg-2 col-md-3">

                            <button
                                type="button"
                                onClick={loaddata}
                                disabled={isLoading}
                                className="btn btn-primary w-100"
                                style={{
                                    height: '43px',
                                    borderRadius: '9px',
                                    boxShadow:
                                        '0 5px 15px rgba(13,110,253,.20)'
                                }}
                            >

                                <i className="fa-solid fa-magnifying-glass-chart me-2"></i>

                                Show

                            </button>

                        </div>


                        {/* EXCEL */}

                        <div className="col-xl-2 col-lg-2 col-md-3">

                            <button
                                type="button"
                                onClick={exportToExcel}
                                disabled={data.length === 0}
                                className="btn btn-success w-100"
                                style={{
                                    height: '43px',
                                    borderRadius: '9px'
                                }}
                            >

                                <i className="fa-solid fa-file-excel me-2"></i>

                                Excel

                            </button>

                        </div>


                        {/* PDF */}

                        <div className="col-xl-2 col-lg-2 col-md-3">

                            <PDFDownloadLink
                                document={
                                    <PDFDocument
                                        data={data}
                                        fromdate={fromdate}
                                        todate={todate}
                                    />
                                }
                                fileName="Pending Lot.pdf"
                                className="text-decoration-none"
                            >

                                {({ loading }) => (

                                    <button
                                        type="button"
                                        disabled={
                                            data.length === 0 ||
                                            loading
                                        }
                                        className="btn btn-danger w-100"
                                        style={{
                                            height: '43px',
                                            borderRadius: '9px'
                                        }}
                                    >

                                        <i className="fa-regular fa-file-pdf me-2"></i>

                                        {loading
                                            ? 'Loading'
                                            : 'PDF'}

                                    </button>

                                )}

                            </PDFDownloadLink>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                SUMMARY CARDS
            ================================================= */}

            <div className="row g-3 mb-3">


                {/* RECORDS */}

                <div className="col-xl-4 col-md-4">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '15px',
                            boxShadow:
                                '0 5px 20px rgba(0,0,0,.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between align-items-center">

                                <div>

                                    <div className="text-muted small">
                                        Total Records
                                    </div>

                                    <h3 className="fw-bold mb-0 mt-1">
                                        {data.length}
                                    </h3>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: '45px',
                                        height: '45px',
                                        borderRadius: '12px',
                                        background: '#eaf2ff',
                                        color: '#0d6efd'
                                    }}
                                >

                                    <i className="fa-solid fa-list"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* LOTS */}

                <div className="col-xl-4 col-md-4">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '15px',
                            boxShadow:
                                '0 5px 20px rgba(0,0,0,.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between align-items-center">

                                <div>

                                    <div className="text-muted small">
                                        Total Lots
                                    </div>

                                    <h3 className="fw-bold mb-0 mt-1">
                                        {uniqueLots}
                                    </h3>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: '45px',
                                        height: '45px',
                                        borderRadius: '12px',
                                        background: '#fff3cd',
                                        color: '#f59f00'
                                    }}
                                >

                                    <i className="fa-solid fa-box"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>


                {/* QTY */}

                <div className="col-xl-4 col-md-4">

                    <div
                        className="card border-0 h-100"
                        style={{
                            borderRadius: '15px',
                            boxShadow:
                                '0 5px 20px rgba(0,0,0,.06)'
                        }}
                    >

                        <div className="card-body">

                            <div className="d-flex justify-content-between align-items-center">

                                <div>

                                    <div className="text-muted small">
                                        Pending Quantity
                                    </div>

                                    <h3 className="fw-bold mb-0 mt-1">
                                        {totalQty}
                                    </h3>

                                </div>

                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        width: '45px',
                                        height: '45px',
                                        borderRadius: '12px',
                                        background: '#e8f7ee',
                                        color: '#198754'
                                    }}
                                >

                                    <i className="fa-solid fa-cubes-stacked"></i>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                TABLE CARD
            ================================================= */}

            <div
                className="card border-0"
                style={{
                    borderRadius: '18px',
                    overflow: 'hidden',
                    boxShadow:
                        '0 6px 25px rgba(31,45,61,.07)'
                }}
            >


                {/* TABLE TOP */}

                <div
                    className="px-3 px-md-4 py-3 border-bottom d-flex justify-content-between align-items-center"
                    style={{
                        background: '#fff'
                    }}
                >

                    <div>

                        <h6 className="fw-bold mb-0">

                            <i className="fa-solid fa-table text-primary me-2"></i>

                            Lot Details

                        </h6>

                        <small className="text-muted">
                            Production pending details
                        </small>

                    </div>


                    {lotno && (

                        <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                                background: '#eaf2ff',
                                color: '#0d6efd'
                            }}
                        >

                            <i className="fa-solid fa-barcode me-1"></i>

                            {lotno}

                        </span>

                    )}

                </div>


                {/* TABLE */}

                <div
                    className="table-responsive"
                    style={{
                        maxHeight: '620px'
                    }}
                >

                    <table
                        className="table table-hover align-middle mb-0"
                        ref={tableRef}
                    >

                        <thead
                            style={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 5,
                                background: '#f8f9fa'
                            }}
                        >

                            <tr>

                                <th
                                    className="text-start py-3 px-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Lot No
                                </th>

                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Type
                                </th>

                                <th
                                    className="text-start py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Name
                                </th>

                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Style
                                </th>

                                <th
                                    className="text-end py-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Size
                                </th>

                                <th
                                    className="text-end py-3 px-3"
                                    style={{
                                        fontSize: '12px',
                                        color: '#6c757d'
                                    }}
                                >
                                    Qty
                                </th>

                            </tr>

                        </thead>


                        <tbody>

                            {data.length === 0 ? (

                                <tr>

                                    <td
                                        colSpan="6"
                                        className="text-center py-5"
                                    >

                                        <div
                                            className="d-flex flex-column align-items-center"
                                        >

                                            <div
                                                className="d-flex align-items-center justify-content-center mb-3"
                                                style={{
                                                    width: '65px',
                                                    height: '65px',
                                                    borderRadius: '50%',
                                                    background: '#f1f3f5',
                                                    color: '#adb5bd'
                                                }}
                                            >

                                                <i
                                                    className="fa-solid fa-box-open"
                                                    style={{
                                                        fontSize: '25px'
                                                    }}
                                                ></i>

                                            </div>

                                            <h6 className="fw-bold mb-1">
                                                No Lot Details Found
                                            </h6>

                                            <small className="text-muted">
                                                Enter a Lot No and click Show
                                            </small>

                                        </div>

                                    </td>

                                </tr>

                            ) : (

                                data.map((res, x) => {

                                    const isDuplicate =
                                        x > 0 &&
                                        res.billno ===
                                        data[x - 1].billno;

                                    const type = getType(res);
                                    const name = getName(res);
                                    const qty = getQty(res);

                                    return (

                                        <tr key={x}>

                                            <td
                                                className="text-start px-3"
                                            >

                                                {!isDuplicate && (

                                                    <span
                                                        className="badge rounded-pill"
                                                        style={{
                                                            background: '#eaf2ff',
                                                            color: '#0d6efd',
                                                            fontWeight: '600',
                                                            padding: '7px 10px'
                                                        }}
                                                    >

                                                        {res.billno}

                                                    </span>

                                                )}

                                            </td>


                                            <td className="text-start">

                                                {type.split(' | ').map(
                                                    (item, index) => (

                                                        <span
                                                            key={index}
                                                            className="badge rounded-pill me-1 mb-1"
                                                            style={{
                                                                background:
                                                                    item === 'Fabricator'
                                                                        ? '#eaf2ff'
                                                                        : item === 'Washing'
                                                                            ? '#e8f7ff'
                                                                            : '#fff3cd',
                                                                color:
                                                                    item === 'Fabricator'
                                                                        ? '#0d6efd'
                                                                        : item === 'Washing'
                                                                            ? '#087990'
                                                                            : '#997404',
                                                                fontWeight: '500'
                                                            }}
                                                        >

                                                            {item}

                                                        </span>

                                                    )
                                                )}

                                            </td>


                                            <td
                                                className="text-start"
                                                style={{
                                                    fontWeight: '500'
                                                }}
                                            >

                                                {name}

                                            </td>


                                            <td className="text-end">

                                                {res.style}

                                            </td>


                                            <td className="text-end">

                                                {res.size}

                                            </td>


                                            <td
                                                className="text-end px-3"
                                            >

                                                <span
                                                    className="fw-bold"
                                                >
                                                    {qty}
                                                </span>

                                            </td>

                                        </tr>

                                    );

                                })

                            )}

                        </tbody>

                    </table>

                </div>


                {/* FOOTER */}

                {data.length > 0 && (

                    <div
                        className="px-3 px-md-4 py-3 border-top d-flex justify-content-between align-items-center"
                        style={{
                            background: '#fafbfc'
                        }}
                    >

                        <small className="text-muted">

                            Showing{' '}
                            <strong>
                                {data.length}
                            </strong>{' '}
                            records

                        </small>


                        <div>

                            <span className="text-muted me-2">
                                Total Qty
                            </span>

                            <span
                                className="badge bg-primary rounded-pill px-3 py-2"
                            >
                                {totalQty}
                            </span>

                        </div>

                    </div>

                )}

            </div>


            <ToastContainer autoClose={1000} />

            {isLoading && <Loading />}

        </div>
    );
};


// =========================================================
// PDF DOCUMENT
// =========================================================

const PDFDocument = ({
    data,
    fromdate,
    todate
}) => {

    const getQty = (res) => {

        if (res.entrytype === 1) {
            return res.pcs ? `${res.pcs}` : '';
        }

        if (res.entrytype === 2) {
            return res.washqty ? `${res.washqty}` : '';
        }

        if (res.entrytype === 3) {
            return res.finishqty ? `${res.finishqty}` : '';
        }

        if (res.entrytype === 4) {
            return res.godwstk ? `${res.godwstk}` : '';
        }

        return '';
    };


    const getType = (res) => {

        return [
            res.fabname ? 'Fabricator' : '',
            res.wname ? 'Washing' : '',
            res.finisharname ? 'Finishing' : ''
        ]
            .filter(Boolean)
            .join(' | ');

    };


    const getName = (res) => {

        return [
            res.fabname ? res.fabname : '',
            res.wname ? res.wname : '',
            res.finisharname ? res.finisharname : ''
        ]
            .filter(Boolean)
            .join(' | ');

    };


    return (

        <Document>

            <Page
                orientation="landscape"
                size="A4"
            >

                <View style={styles.container}>

                    <Text style={styles.title}>
                        Pending Lot
                    </Text>

                    <Text style={styles.subtitle}>
                        From {fromdate} To {todate}
                    </Text>


                    <View style={styles.table}>

                        <View style={styles.tableRow}>

                            <Text style={styles.headerCell}>
                                Lot No
                            </Text>

                            <Text style={styles.headerCell}>
                                Type
                            </Text>

                            <Text style={styles.headerCell}>
                                Name
                            </Text>

                            <Text style={styles.headerCell}>
                                Style
                            </Text>

                            <Text style={styles.headerCell}>
                                Size
                            </Text>

                            <Text style={styles.headerCell}>
                                Qty
                            </Text>

                        </View>


                        {data.map((res, x) => {

                            const isDuplicate =
                                x > 0 &&
                                res.billno ===
                                data[x - 1].billno;

                            return (

                                <View
                                    key={x}
                                    style={styles.tableRow}
                                >

                                    <Text style={styles.cell}>
                                        {!isDuplicate
                                            ? res.billno
                                            : ''}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {getType(res)}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {getName(res)}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.style}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {res.size}
                                    </Text>

                                    <Text style={styles.cell}>
                                        {getQty(res)}
                                    </Text>

                                </View>

                            );

                        })}

                    </View>

                </View>

            </Page>

        </Document>
    );
};


// =========================================================
// PDF STYLES
// =========================================================

const styles = StyleSheet.create({

    container: {
        padding: 20
    },

    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 5,
        textAlign: 'center'
    },

    subtitle: {
        fontSize: 9,
        marginBottom: 15,
        textAlign: 'center'
    },

    table: {
        display: 'table',
        width: '100%'
    },

    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#cccccc'
    },

    headerCell: {
        fontSize: 8,
        fontWeight: 'bold',
        padding: 6,
        flex: 1,
        textAlign: 'center'
    },

    cell: {
        fontSize: 8,
        padding: 6,
        flex: 1,
        textAlign: 'center'
    }

});


export default FindLotDetail;

